import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import React, {useEffect, useState} from 'react';

import {ISupplierUserProfile, ISupportCustomer} from 'constants/interfaces';
import {
  ChangeAccountManagerForm,
  ChangeAccountManagerFormSubmission,
} from 'components/Farmer/ChangeAccountManagerForm';
import {apiGetTeam, apiMoveSupportCustomer} from 'constants/Api';

export function ChangeAccountManagerDialog(props: {
  user: ISupplierUserProfile;
  customer?: ISupportCustomer;
  open: boolean;
  onClose: VoidFunction;
  onSuccess: VoidFunction;
}) {
  const [team, setTeam] = useState<ISupplierUserProfile[]>([]);
  const [isLoadingTeam, setIsLoadingTeam] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    setIsLoadingTeam(true);
    apiGetTeam()
      .then(setTeam)
      .catch((err) => {
        alert('Failed to load team members. Please try again later');
        console.error(err);
        setTeam([]);
      })
      .finally(() => setIsLoadingTeam(false));
  }, []);

  const handleUpdate = (submission: ChangeAccountManagerFormSubmission) => {
    if (!props.customer) return;
    setIsUpdating(true);
    apiMoveSupportCustomer(
      props.customer.farmer.id.toString(),
      submission.supplierId,
    )
      .then(() => {
        props.onSuccess();
        props.onClose();
      })
      .catch((err) => {
        alert('Failed to change account manager. Please try again later');
        console.error(err);
      })
      .finally(() => setIsUpdating(false));
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      className="update-password-dialog"
    >
      <DialogTitle>Change Account Manager</DialogTitle>
      <DialogContent>
        <ChangeAccountManagerForm
          team={team}
          isLoading={isLoadingTeam || isUpdating}
          cancelButtonTitle="Cancel"
          onCancel={props.onClose}
          submitButtonTitle="Update"
          onSubmit={handleUpdate}
        />
      </DialogContent>
    </Dialog>
  );
}
